import { YouTubeLivePlayer } from './YouTubeLivePlayer';

/**
 * Drone media tile (#216 — drone feed as a media-tile kind).
 *
 * The drone twin of {@link NewsMedia}. There is no live drone-video ingest yet, so
 * a drone feed is backed by the curated `DRONE_SOURCES` stub and resolves through
 * the SAME shared YouTube-live path (`/api/drone-feeds/:id/youtube`, reusing the
 * camera path's channel-live resolver). So a drone tile gets the exact same
 * liveness / "not live" / "unavailable" chrome the camera + news tiles use — no
 * duplicate player. (See `packages/shared-types/src/drone-source.ts` for the
 * stub-source rationale; a real agency/partner relay would swap the backing path
 * without touching this tile.)
 *
 * Drone feeds are AMBIENT + operator-gated: pop-out is off by default (the
 * panel/wall IS the surface) and there is no red/anomaly treatment anywhere here —
 * it's just a live video tile. `id` is the registry slug (the `kind:'drone'` pin
 * id); `label` is its caption.
 */
export function DroneMedia({
  id,
  label,
  enablePopout = false,
  fill = false,
  chromeless = false,
}: {
  id: string;
  label: string;
  enablePopout?: boolean;
  /** Wall fill mode (#232) — passed through to the shared YouTube player. */
  fill?: boolean;
  /** Suppress embed + overlay chrome (#232) — passed through likewise. */
  chromeless?: boolean;
}): JSX.Element {
  return (
    <YouTubeLivePlayer
      cameraId={id}
      name={label}
      enablePopout={enablePopout}
      resolveUrl={`/api/drone-feeds/${encodeURIComponent(id)}/youtube`}
      fill={fill}
      chromeless={chromeless}
    />
  );
}
